import React from 'react';

const GamesHeroSection = () => {
  return (
    <section aria-labelledby="games-hero-title" className="site-bg-hero text-center py-16 px-6">
      <h1
        id="games-hero-title"
        className="text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl"
      >
        Laboratorio
      </h1>
      <p className="mt-6 text-lg leading-8 text-gray-600">
        Um laboratorio de curiosidades, APIs e jogos, mantendo o mesmo tom profissional do site.
      </p>
    </section>
  );
};

export default GamesHeroSection;
